import { makeStyles } from 'tss-react/mui';
import { theme } from '../../theme';

/**
 * Custom hook that defines the styles for the search users page component.
 */
const useSearchUsersPageStyles = makeStyles()(() => ({
  searchBar: {
    maxWidth: '300px',
    margin: `0 ${theme.margin.m}`,
  },
  searchUsers: {
    padding: `${theme.margin.m} ${theme.margin.l}`,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.gap.l,
  },
  searchUserItem: {
    boxShadow: theme.containerShadow,
    padding: theme.padding.xs,
    borderRadius: theme.borderRadius.s,
    width: '30%',
    cursor: 'pointer',
    fontFamily: theme.fontFamily,
    fontSize: theme.fontSize.h5,
    textTransform: 'none',
    color: theme.text.primary.light,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    backgroundColor: theme.background.paper,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.gap.l,
  },
}));

export default useSearchUsersPageStyles;
